import { Injectable } from '@angular/core';
import { BSData, BSFilters, BSFilterItem } from 'src/app/common/components/browse-and-select/BrowseAndSelectModel';
import { PublisherDealType } from '../enums/PublisherDealType.enum';
import { KPI } from '../components/planner-edit/constants/KPI.const';
import * as _ from 'lodash';

@Injectable()
export class InventoryFilterService {

    public KPIFilter = {
        filterType: 'checkbox',
        key: 'kpis',
        label: 'KPI',
        options: [
            {
                label: KPI.CTR.label,
                value: KPI.CTR.key
            },
            {
                label: KPI.CompletionRate.label,
                value: KPI.CompletionRate.key
            },
            {
                label: KPI.InDemo.label,
                value: KPI.InDemo.key
            },
            {
                label: KPI.Performance.label,
                value: KPI.Performance.key
            },
            {
                label: KPI.Viewability.label,
                value: KPI.Viewability.key
            }
        ]
    };

    public dealTypeFilter = {
        filterType: 'checkbox',
        key: 'dealType',
        label: 'Type',
        options: [
            {
                label: 'Private Auction',
                value: PublisherDealType.PrivateAuction.toString()
            },
            {
                label: 'Unreserved Fixed',
                value: PublisherDealType.UnreservedFixed.toString()
            }
        ]
    };

    constructor() { }

    public sortBy(data: Array<any>, field: string): Array<any> {
        // note data itself is also sorted in place
        data.sort((a, b) => {
            var nameA = a[field].toString().toUpperCase();
            var nameB = b[field].toString().toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        return data;
    }

    public inventorySourceFilter(data: Array<BSData>, filter: any): Array<BSData> {
        let result = [];
        if (filter.searchString && filter.searchString.length) {
            let upperCaseString = filter.searchString.toUpperCase();
            result = data.filter((d: BSData) => {
                return d.id == upperCaseString || d.description.toUpperCase().includes(upperCaseString);
            });
        } else {
            result = [].concat(data);
        }
        return result;
    }

    public publisherDealFilter(data: Array<BSData>, filter: any): Array<BSData> {
        let kpis = filter.kpis ? filter.kpis : [];
        let dealTypes = filter.dealType ? filter.dealType : [];
        let invSource = filter.invSource ? filter.invSource : '';
        let publisher = filter.publisher ? filter.publisher : '';
        let searchString = filter.searchString ? filter.searchString.toUpperCase() : '';

        return data.filter((d: BSData) => {
            if (kpis.length > 0 && (!d.kpis || _.intersection(kpis, d.kpis).length === 0)) {
                return false;
            }
            if (dealTypes.length > 0 && !dealTypes.includes(d.dealType.toString())) {
                return false;
            }
            if (invSource.length > 0 && d.invSource !== invSource) {
                return false;
            }
            if (publisher.length > 0 && d.publisher !== publisher) {
                return false;
            }
            if (searchString.length > 0 && !d.name.toUpperCase().includes(searchString) && !d.publisherDealId.toString().toUpperCase().includes(searchString)) {
                return false;
            }

            return true;
        });
    }

    public getDealFiltersFromData(data: Array<BSData>, section: 'privateDeals' | 'preferredDeals' | 'pgDeals'): Array<BSFilters> {
        let filters = [];

        if (section === 'privateDeals' || section === 'preferredDeals') {
            filters.push(this.KPIFilter);
            filters.push(this.dealTypeFilter);
        }

        let invSrcList = [];
        let invSrcMap = {};
        let publisherList = [];
        let publisherMap = {};
        if (data && data.length) {
            data.forEach((d: BSData) => {
                if (!invSrcMap[d.invSource]) {
                    invSrcMap[d.invSource] = true;
                    invSrcList.push(d.invSource);
                }
                if (!publisherMap[d.publisher]) {
                    publisherMap[d.publisher] = true;
                    publisherList.push(d.publisher);
                }
            });
            invSrcList.sort();
            publisherList.sort();
        }

        let invSrcFilter: BSFilters = {
            filterType: 'autoComplete',
            key: 'invSource',
            label: 'Inventory Sources',
            onFilterSearchStringChanged: this.bindDataForAutoCompleteFilter(invSrcList),
            autoCompleteSingleSelection: true
        };

        let publisherFilter: BSFilters = {
            filterType: 'autoComplete',
            key: 'publisher',
            label: 'Publisher',
            onFilterSearchStringChanged: this.bindDataForAutoCompleteFilter(publisherList),
            autoCompleteSingleSelection: true
        };

        filters.push(invSrcFilter);
        filters.push(publisherFilter);

        return filters;
    };

    private bindDataForAutoCompleteFilter(data: Array<string>) {
        return function (param: { searchString: string }): Promise<Array<BSFilterItem>> {
            let result = [];
            let upperCaseString = param.searchString ? param.searchString.toUpperCase() : '';
            data.forEach((name: string) => {
                if (name.toUpperCase().includes(upperCaseString)) {
                    result.push({
                        label: name,
                        value: name
                    })
                }
            });
            return Promise.resolve(result);
        };
    }



}
